module.exports = __webpack_public_path__ + "img/1_hybrid-car-sp.314ee032.gif";